import React from 'react';


/**
 * Diet Cards Remover component
 */
const DietCardsRemover = (props) => (
  <div className="nppe2-fc-diet-cards-map">
    {
      props.selected.map((key) =>
        <div className="nppe2-fc-close-button" key={key}>
          <div className="nppe2-fc-close-button__btn">
            <div
              className="nppe2-fc-close-button__text">{props.data.data[props.type][key].label}</div>
            <div className="nppe2-fc-close-button__close">
              <a onClick={() => props.onRemove(key)}>
                x
              </a>
            </div>
          </div>
        </div>
      )
    }
  </div>
);

export default DietCardsRemover;
